import React, { useState, useEffect } from "react";
import cx from "classnames";
import Icon from "components/CommonIcon/Icon";

const InputCustom = ({
  className,
  icon,
  prefixIcon,
  placeholder,
  ...props
}) => {
  const [showPlaceholder, setShowPlaceholder] = useState(false);

  useEffect(() => {
    if (props.defaultValue) props.onChange(props.defaultValue);
  }, []);

  const handleFocus = () => {
    !props.value && placeholder && setShowPlaceholder(true);
  };

  useEffect(() => {
    if (placeholder) {
      props.value && setShowPlaceholder(false);
    }
  }, [props.value]);

  return (
    <div className="flex justify-end items-center" onFocus={handleFocus}>
      {prefixIcon && (
        <span className="absolute left-16 z-1">
          <Icon name={prefixIcon} fontSize="text-24" />
        </span>
      )}
      <input
        className={cx(
          "input-field relative font-mulish text-14 text-gray-text leading-22 tracking-2 w-full px-12 py-12 border border-gray-med rounded-sm outline-none focus:border-blue-ayana z-1 appearance-none",
          className,
          {
            "cursor-pointer": Boolean(icon) || Boolean(prefixIcon),
            "pl-48": prefixIcon,
          }
        )}
        {...props}
        placeholder={showPlaceholder && placeholder}
      />
      {icon && (
        <span className="absolute pr-16 z-1">
          <Icon name={icon} fontSize="text-16" />
        </span>
      )}
    </div>
  );
};
InputCustom.defaultProps = {
  className: "",
};

export default InputCustom;
